import { render, staticRenderFns } from "./NotificationCustomer.vue?vue&type=template&id=cc66a896&scoped=true&"
import script from "./NotificationCustomer.vue?vue&type=script&lang=js&"
export * from "./NotificationCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCustomer.vue?vue&type=style&index=0&id=cc66a896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc66a896",
  null
  
)

export default component.exports